import React from 'react';
import './about.css';
import Button from '../../components/button/Button';
import aboutimg from '../../assets/about.png';
import whatsapp from "../../assets/whatsapp.png";
import gmail from "../../assets/gmail.png";

const About = () => {
  return (
    <div className='about-container'>

      <Button text="Atrás" route="/" />

      <div className="about-card">
        <p className="about-text">
          Somos NK Repuestos Marcos Paz, una empresa dedicada a la venta de repuestos de electrodomésticos en todo el país.
        </p>

        <img src={ aboutimg } alt="" className="about-img" />

        <p className="about-info">
          Somos Mercado Líder Platinum, 14 años vendiendo en Mercado Libre, contamos con más de 35.000 publicaciones a la venta.
          Ingeniero en electrónica desde hace 35 años. Estamos ubicados en Marcos Paz... Puede visitar nuestro perfil clickeando en el enlace de abajo!
        </p>

        <a href="https://listado.mercadolibre.com.ar/_CustId_86060871?item_id=MLA1339184874&category_id=MLA409593&seller_id=86060871&client=recoview-selleritems&recos_listing=true#origin=vip&component=sellerData&typeSeller=classic" target="_blank">
          <button className="btn-ml">
            Visitar nuestro perfil
          </button>
        </a>

        <p className="about-info">
          Tambien puede comunicarse con nosotros escribiéndonos a nuestro Whatsapp:
        </p>

        <div className="contact-card">

        <div className="contact-data">
          <img src={whatsapp} alt="" className="contact-img" />
            <a href="https://wa.me/+541131727778" target="_blank" className="contact-info">
              +54 11 3172-7778
            </a>
        </div>

        {/* <div className="contact-data">
          <img src={gmail} alt="" className="contact-img" />
          <p className="contact-info">munitedtecni@gmail.com</p>
        </div> */}
        </div>
      </div>

    </div>
  )
}

export default About